import { controlePatientStatusStyle } from "../controlePatientStyles";
import { CHARTER_COLORS as theme, PATIENT_STATUS_PALETTE, validationStatusColors } from "../shared/controleTheme";
import { buttonBase, dossierActionButtonStyle } from "../shared/styles/layoutStyles";
import { controlePatientCountStyle } from "../shared/styles/patientStyles";

export const inputStyle = {
    border: `1px solid ${theme.borderStrong}`,
    borderRadius: "7px",
    padding: "7px 9px",
    fontSize: "13px",
    background: "white",
    color: theme.ink,
    boxSizing: "border-box",
};

export const saveDossierButtonStyle = {
    ...dossierActionButtonStyle,
    background: theme.primary,
    borderColor: theme.primary,
    color: "white",
};

export const validateDossierButtonStyle = {
    ...dossierActionButtonStyle,
    background: theme.accent,
    borderColor: theme.accent,
    color: "white",
};

export const sectionTitleStyle = {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginTop: "8px",
    padding: "11px 14px",
    borderRadius: "8px",
    background: "#e2f5ee",
    border: "1px solid #b9d4cc",
    color: theme.ink,
    fontSize: "15px",
    fontWeight: 900,
    boxShadow: "0 1px 2px rgba(12, 59, 60, 0.06)",
};

export const sectionTitleMarkerStyle = {
    width: "8px",
    height: "28px",
    borderRadius: "999px",
    background: theme.accent,
    flexShrink: 0,
};

export function launchStatusInputStyle(value) {
    return {
        ...inputStyle,
        ...validationStatusColors(value),
        width: "100%",
        fontWeight: 900,
    };
}

export const controleTabsStyle = {
    display: "inline-flex",
    alignSelf: "flex-start",
    gap: "3px",
    padding: "3px",
    border: `1px solid ${theme.borderStrong}`,
    borderRadius: "7px",
    background: theme.surfaceMuted,
};

export const printReportButtonStyle = {
    ...buttonBase,
    minHeight: "38px",
    padding: "8px 14px",
    background: theme.primary,
    borderColor: theme.primary,
    color: "white",
    fontWeight: 900,
    boxShadow: "0 6px 14px rgba(12, 59, 60, 0.12)",
};

export const controleTabButtonStyle = active => ({
    border: 0,
    borderRadius: "5px",
    padding: "8px 14px",
    cursor: "pointer",
    background: active ? "white" : "transparent",
    color: active ? theme.ink : theme.muted,
    fontWeight: active ? 800 : 700,
    boxShadow: active ? "0 1px 3px rgba(12, 59, 60, 0.12)" : "none",
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
});

export const controleTabBadgeStyle = active => ({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "34px",
    height: "20px",
    padding: "0 7px",
    borderRadius: "999px",
    background: active ? theme.primarySoft : "white",
    color: active ? theme.primary : theme.muted,
    border: `1px solid ${theme.border}`,
    fontSize: "11px",
    fontWeight: 900,
});

export const controlePatientWorkspaceStyle = {
    display: "grid",
    gridTemplateColumns: "minmax(230px, 300px) minmax(0, 1fr)",
    gap: "14px",
    alignItems: "start",
};

export const controlePatientSidebarStyle = {
    display: "grid",
    position: "sticky",
    top: "12px",
    alignSelf: "start",
    background: "white",
    border: `1px solid ${theme.border}`,
    borderRadius: "8px",
    overflow: "hidden",
    boxShadow: "0 4px 16px rgba(12, 59, 60, 0.05)",
    maxHeight: "calc(100vh - 280px)",
};

export const controlePatientHeaderStyle = {
    display: "grid",
    gap: "9px",
    padding: "14px",
    borderBottom: `1px solid ${theme.border}`,
};

export const controlePatientItemWrapperStyle = (active, inactive, validated, blocking) => ({
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    border: 0,
    borderRadius: "8px",
    ...controlePatientStatusStyle({ active, inactive, validated, blocking }, PATIENT_STATUS_PALETTE),
    marginBottom: "3px",
});

export const controlePatientAvatarStyle = (active, inactive, validated, blocking) => ({
    width: "34px",
    height: "34px",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: inactive ? theme.danger : blocking ? theme.warning : validated ? theme.accent : active ? theme.primary : theme.primarySoft,
    color: inactive || active || validated || blocking ? "white" : theme.primary,
    fontWeight: 800,
    fontSize: "11px",
    flexShrink: 0,
});

export const controlePatientWarningCountStyle = {
    ...controlePatientCountStyle,
    background: theme.dangerSoft,
    color: theme.danger,
    border: "1px solid #fecaca",
};

export const patientValidateButtonStyle = {
    ...buttonBase,
    height: "32px",
    padding: "0 12px",
    background: theme.primary,
    borderColor: theme.primary,
    color: "white",
    fontWeight: 900,
};

export const patientValidatedButtonStyle = {
    ...patientValidateButtonStyle,
    background: theme.successSoft,
    borderColor: "#a9e8cf",
    color: "#0d704a",
};

export const patientValidateAllPointsButtonStyle = {
    ...buttonBase,
    height: "32px",
    padding: "0 12px",
    background: theme.primarySoft,
    borderColor: "#b9d4cc",
    color: theme.primary,
    fontWeight: 900,
};

export const controlePatientDetailStyle = {
    display: "grid",
    gap: "14px",
    background: "white",
    border: `1px solid ${theme.border}`,
    borderRadius: "8px",
    padding: "16px",
};

export const controlePatientEmptyDetailStyle = {
    ...controlePatientDetailStyle,
    minHeight: "180px",
    alignContent: "center",
    justifyItems: "center",
    textAlign: "center",
};

export const controlePatientDetailHeaderStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "12px",
    paddingBottom: "12px",
    borderBottom: `1px solid ${theme.border}`,
};

export const lastDossierEmptyStyle = {
    padding: "18px",
    borderRadius: "8px",
    border: `1px dashed ${theme.borderStrong}`,
    background: theme.surfaceMuted,
    color: theme.muted,
    fontSize: "13px",
};

export const lastDossierPanelStyle = {
    display: "grid",
    gap: "12px",
};

export const lastDossierMetaStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "8px",
    padding: "12px",
    borderRadius: "8px",
    border: "1px solid #b9d4cc",
    background: theme.primarySoft,
    color: theme.ink,
    fontSize: "13px",
};

export const lastDossierPointsStyle = {
    display: "grid",
    gap: "10px",
};

export const lastDossierPointStyle = validated => ({
    display: "grid",
    gap: "8px",
    padding: "12px",
    borderRadius: "8px",
    border: validated ? "1px solid #86efac" : "1px solid #fecaca",
    background: validated ? "#f0fdf4" : "#fff7f7",
});

export const controlePointListStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(310px, 1fr))",
    gap: "10px",
};

export const controlePatientPointCardStyle = (validated, blocking) => ({
    display: "grid",
    gap: "12px",
    minHeight: "180px",
    padding: "12px",
    borderRadius: "8px",
    border: blocking ? "1px solid #fecaca" : validated ? "1px solid #86efac" : `1px solid ${theme.border}`,
    background: blocking ? "#fff7f7" : validated ? "#f0fdf4" : theme.surfaceMuted,
});

export const patientLaunchStatusCardStyle = launched => ({
    display: "grid",
    alignContent: "space-between",
    gap: "14px",
    minHeight: "180px",
    padding: "12px",
    borderRadius: "8px",
    border: launched ? "1px solid #86efac" : "1px solid #fed7aa",
    background: launched ? "#f0fdf4" : "#fff7ed",
});

export const patientLaunchMetaStyle = {
    display: "grid",
    gap: "3px",
    padding: "9px 10px",
    borderRadius: "8px",
    background: "white",
    border: "1px solid #a9e8cf",
    color: "#166534",
    fontSize: "12px",
    fontWeight: 850,
};
